import styled from 'styled-components';
import { Grid } from 'react-styled-flexboxgrid';

export default styled(Grid)`
  .user-top {
    padding-top: 70px;
  }
  .avatar {
    height: 170px;
    width: 400px;
  }
  .tabs-section {
    padding-top: 60px;
    padding-left: 15px;
    .tabs {
      flex-direction: row;
      justify-content: flex-start;
      padding-top: 10px;
      padding-bottom: 10px;
      & > button {
        margin-right: 50px;
        display: inline-flex;
        margin-bottom: 15px;
      }
    }
  }
`;

const DateWrapper = styled('div')`
  padding: 0 5px;
  .date {
    color: #595959;
    font-size: 13px;
    img {
      margin-right: 5px;
      vertical-align: text-top;
    }
  }
  @media screen and (max-width: 1023px) {
    padding: 0;
    img {
      display: none;
    }
  }
  @media screen and (max-width: 767px) {
    font-weight: bold;
    img {
      display: inline;
    }
  }
`;

const TitleWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  margin-left: 2%;
  max-width: 15vw;
  a {
    cursor: pointer;
    color: #595959;
  }
  .title {
    span {
      font-weight: bold;
      font-size: 15px;
      margin-top: 10px;
      margin-bottom: 5px;
    }
    a {
      color: #0a2e3e;
    }
  }
  img {
    margin-right: 5px;
    margin-top: 5px;
    height: 13px;
  }
  .localisation {
    img {
      margin-left: 20px;
    }
  }

  @media screen and (max-width: 1023px) {
    margin-left: 10px;
    .titleFav {
      display: flex;
      flex-direction: column;
      .localisation {
        img {
          margin-left: 0;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    display: block;
    max-width: 100%;
    .title {
      font-size: 13px;
    }
    .titleFav {
      flex-direction: row;
      justify-content: space-between;
      margin-left: 0;
      margin-bottom: 5px;
      .localisation {
        img {
          margin-right: 5px;
          margin-top: 5px;
        }
      }
    }
  }
`;

const PriceWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  color: #00bcd4;
  font-weight: bold;
  padding: 0 5px;

  @media screen and (max-width: 1023px) {
    padding: 0;
  }
  @media screen and (max-width: 767px) {
    font-size: 13px;
    display: block;
  }
`;

const ImageWrapper = styled('div')`
  margin-left: 2%;
  width: 190px;
  @media screen and (max-width: 1023px) {
    width: 150px;
  }
  @media screen and (max-width: 767px) {
    margin: 0 auto;
    width: 100%;
    text-align: center;
    img {
      max-width: 100%;
      dislay: block;
      margin: 0px;
      height: 200px !important;
    }
  }
`;

const ActionWrapper = styled('div')`
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
  a {
    color: #002f3f;
    margin: 2%;
  }
  .boost {
    border-radius: 4px;
    background-color: #00bcd4;
    color: #fff;
    font-family: Poppins;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    padding: 10px 10px;
    transition-duration: 0.4s;
    white-space: nowrap;
    &:hover {
      background-color: rgb(0, 47, 63);
    }
  }
  .delete {
    color: #ff5b60;
  }
  @media screen and (max-width: 1023px) {
    text-align: center;
    display: flex;
    flex-direction: column;
    .boost {
      padding: 8px 10px;
    }
  }
  @media screen and (max-width: 767px) {
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0;
    font-size: 15px;
    .boost {
      padding: 10px 20px;
    }
  }
`;

export { DateWrapper, TitleWrapper, PriceWrapper, ImageWrapper, ActionWrapper };
